export function isLocalhostHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

/** Production: paqshot.com (primary) + legacy prosecaptain.com / design.prosecaptain.com */
export function isProductionHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!host || isLocalhostHost(host)) return false;
  return (
    host === 'paqshot.com' ||
    host.endsWith('.paqshot.com') ||
    host === 'prosecaptain.com' ||
    host.endsWith('.prosecaptain.com')
  );
}

export const PAQSHOT_APP_URL = 'https://app.paqshot.com';
export const PAQSHOT_API_URL = 'https://api.paqshot.com';
export const PAQSHOT_PANEL_URL = 'https://panel.paqshot.com';
export const LEGACY_DESIGN_APP_URL = 'https://design.prosecaptain.com';

export function getSsoProfileUrl(returnTo: string, hash = '#subscription'): string {
  return `https://app.prosecaptain.com/profile?from_app=design&return_to=${encodeURIComponent(returnTo)}${hash}`;
}
